export default __webpack_public_path__ + "static/media/arrowLeft.ff99d446.svg";